var cov_2mn452mohk = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rate/Rate.tsx",
      hash = "6fa058042b75b95d8f616b2d8170456bcdddab9d",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rate/Rate.tsx",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 17
        },
        end: {
          line: 11,
          column: 19
        }
      },
      "1": {
        start: {
          line: 18,
          column: 21
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "2": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 16
        }
      },
      "3": {
        start: {
          line: 34,
          column: 4
        },
        end: {
          line: 37,
          column: 5
        }
      },
      "4": {
        start: {
          line: 41,
          column: 22
        },
        end: {
          line: 41,
          column: 32
        }
      },
      "5": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 42,
          column: 57
        }
      },
      "6": {
        start: {
          line: 46,
          column: 21
        },
        end: {
          line: 46,
          column: 31
        }
      },
      "7": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 31
        }
      },
      "8": {
        start: {
          line: 47,
          column: 15
        },
        end: {
          line: 47,
          column: 31
        }
      },
      "9": {
        start: {
          line: 48,
          column: 19
        },
        end: {
          line: 48,
          column: 60
        }
      },
      "10": {
        start: {
          line: 49,
          column: 4
        },
        end: {
          line: 49,
          column: 91
        }
      },
      "11": {
        start: {
          line: 53,
          column: 41
        },
        end: {
          line: 53,
          column: 51
        }
      },
      "12": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 54,
          column: 42
        }
      },
      "13": {
        start: {
          line: 54,
          column: 26
        },
        end: {
          line: 54,
          column: 42
        }
      },
      "14": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "15": {
        start: {
          line: 61,
          column: 34
        },
        end: {
          line: 61,
          column: 44
        }
      },
      "16": {
        start: {
          line: 62,
          column: 18
        },
        end: {
          line: 62,
          column: 33
        }
      },
      "17": {
        start: {
          line: 63,
          column: 19
        },
        end: {
          line: 63,
          column: 28
        }
      },
      "18": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 71,
          column: 5
        }
      },
      "19": {
        start: {
          line: 67,
          column: 6
        },
        end: {
          line: 67,
          column: 18
        }
      },
      "20": {
        start: {
          line: 69,
          column: 6
        },
        end: {
          line: 69,
          column: 42
        }
      },
      "21": {
        start: {
          line: 70,
          column: 6
        },
        end: {
          line: 70,
          column: 47
        }
      },
      "22": {
        start: {
          line: 70,
          column: 17
        },
        end: {
          line: 70,
          column: 47
        }
      },
      "23": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 55
        }
      },
      "24": {
        start: {
          line: 73,
          column: 44
        },
        end: {
          line: 73,
          column: 55
        }
      },
      "25": {
        start: {
          line: 75,
          column: 18
        },
        end: {
          line: 75,
          column: 106
        }
      },
      "26": {
        start: {
          line: 76,
          column: 4
        },
        end: {
          line: 80,
          column: 5
        }
      },
      "27": {
        start: {
          line: 84,
          column: 37
        },
        end: {
          line: 84,
          column: 47
        }
      },
      "28": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 87,
          column: 5
        }
      },
      "29": {
        start: {
          line: 86,
          column: 6
        },
        end: {
          line: 86,
          column: 18
        }
      },
      "30": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 91,
          column: 5
        }
      },
      "31": {
        start: {
          line: 89,
          column: 6
        },
        end: {
          line: 89,
          column: 15
        }
      },
      "32": {
        start: {
          line: 90,
          column: 6
        },
        end: {
          line: 90,
          column: 33
        }
      },
      "33": {
        start: {
          line: 92,
          column: 4
        },
        end: {
          line: 92,
          column: 30
        }
      },
      "34": {
        start: {
          line: 93,
          column: 4
        },
        end: {
          line: 93,
          column: 39
        }
      },
      "35": {
        start: {
          line: 95,
          column: 4
        },
        end: {
          line: 95,
          column: 62
        }
      },
      "36": {
        start: {
          line: 95,
          column: 29
        },
        end: {
          line: 95,
          column: 62
        }
      },
      "37": {
        start: {
          line: 96,
          column: 4
        },
        end: {
          line: 98,
          column: 11
        }
      },
      "38": {
        start: {
          line: 97,
          column: 6
        },
        end: {
          line: 97,
          column: 38
        }
      },
      "39": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 28
        }
      },
      "40": {
        start: {
          line: 106,
          column: 25
        },
        end: {
          line: 106,
          column: 78
        }
      },
      "41": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 112,
          column: 5
        }
      },
      "42": {
        start: {
          line: 109,
          column: 6
        },
        end: {
          line: 109,
          column: 50
        }
      },
      "43": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 111,
          column: 50
        }
      },
      "44": {
        start: {
          line: 113,
          column: 4
        },
        end: {
          line: 113,
          column: 44
        }
      },
      "45": {
        start: {
          line: 117,
          column: 61
        },
        end: {
          line: 117,
          column: 71
        }
      },
      "46": {
        start: {
          line: 118,
          column: 18
        },
        end: {
          line: 118,
          column: 33
        }
      },
      "47": {
        start: {
          line: 119,
          column: 18
        },
        end: {
          line: 119,
          column: 33
        }
      },
      "48": {
        start: {
          line: 121,
          column: 4
        },
        end: {
          line: 133,
          column: 5
        }
      },
      "49": {
        start: {
          line: 124,
          column: 10
        },
        end: {
          line: 130,
          column: 17
        }
      },
      "50": {
        start: {
          line: 137,
          column: 83
        },
        end: {
          line: 137,
          column: 93
        }
      },
      "51": {
        start: {
          line: 138,
          column: 26
        },
        end: {
          line: 138,
          column: 36
        }
      },
      "52": {
        start: {
          line: 139,
          column: 18
        },
        end: {
          line: 139,
          column: 33
        }
      },
      "53": {
        start: {
          line: 140,
          column: 18
        },
        end: {
          line: 140,
          column: 33
        }
      },
      "54": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 163,
          column: 5
        }
      },
      "55": {
        start: {
          line: 145,
          column: 10
        },
        end: {
          line: 159,
          column: 17
        }
      },
      "56": {
        start: {
          line: 167,
          column: 100
        },
        end: {
          line: 167,
          column: 110
        }
      },
      "57": {
        start: {
          line: 168,
          column: 18
        },
        end: {
          line: 168,
          column: 33
        }
      },
      "58": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 179,
          column: 5
        }
      },
      "59": {
        start: {
          line: 173,
          column: 10
        },
        end: {
          line: 175,
          column: 17
        }
      },
      "60": {
        start: {
          line: 183,
          column: 22
        },
        end: {
          line: 183,
          column: 88
        }
      },
      "61": {
        start: {
          line: 184,
          column: 15
        },
        end: {
          line: 184,
          column: 67
        }
      },
      "62": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 190,
          column: 5
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 38
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 32
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 13
          },
          end: {
            line: 43,
            column: 3
          }
        },
        line: 40
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        loc: {
          start: {
            line: 45,
            column: 13
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 45
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 52,
            column: 2
          },
          end: {
            line: 52,
            column: 3
          }
        },
        loc: {
          start: {
            line: 52,
            column: 13
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 52
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 3
          }
        },
        loc: {
          start: {
            line: 60,
            column: 69
          },
          end: {
            line: 81,
            column: 3
          }
        },
        line: 60
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 83,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        },
        loc: {
          start: {
            line: 83,
            column: 50
          },
          end: {
            line: 99,
            column: 3
          }
        },
        line: 83
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 96,
            column: 37
          },
          end: {
            line: 96,
            column: 38
          }
        },
        loc: {
          start: {
            line: 96,
            column: 43
          },
          end: {
            line: 98,
            column: 5
          }
        },
        line: 96
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 101,
            column: 3
          }
        },
        loc: {
          start: {
            line: 101,
            column: 29
          },
          end: {
            line: 103,
            column: 3
          }
        },
        line: 101
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 105,
            column: 2
          },
          end: {
            line: 105,
            column: 3
          }
        },
        loc: {
          start: {
            line: 105,
            column: 66
          },
          end: {
            line: 114,
            column: 3
          }
        },
        line: 105
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 116,
            column: 2
          },
          end: {
            line: 116,
            column: 3
          }
        },
        loc: {
          start: {
            line: 116,
            column: 21
          },
          end: {
            line: 134,
            column: 3
          }
        },
        line: 116
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 123,
            column: 24
          },
          end: {
            line: 123,
            column: 25
          }
        },
        loc: {
          start: {
            line: 124,
            column: 10
          },
          end: {
            line: 130,
            column: 17
          }
        },
        line: 124
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 136,
            column: 2
          },
          end: {
            line: 136,
            column: 3
          }
        },
        loc: {
          start: {
            line: 136,
            column: 15
          },
          end: {
            line: 164,
            column: 3
          }
        },
        line: 136
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 144,
            column: 24
          },
          end: {
            line: 144,
            column: 25
          }
        },
        loc: {
          start: {
            line: 145,
            column: 10
          },
          end: {
            line: 159,
            column: 17
          }
        },
        line: 145
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 166,
            column: 2
          },
          end: {
            line: 166,
            column: 3
          }
        },
        loc: {
          start: {
            line: 166,
            column: 17
          },
          end: {
            line: 180,
            column: 3
          }
        },
        line: 166
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 172,
            column: 24
          },
          end: {
            line: 172,
            column: 25
          }
        },
        loc: {
          start: {
            line: 173,
            column: 10
          },
          end: {
            line: 175,
            column: 17
          }
        },
        line: 173
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 182,
            column: 2
          },
          end: {
            line: 182,
            column: 3
          }
        },
        loc: {
          start: {
            line: 182,
            column: 11
          },
          end: {
            line: 191,
            column: 3
          }
        },
        line: 182
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 18
          },
          end: {
            line: 42,
            column: 56
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 42,
            column: 32
          },
          end: {
            line: 42,
            column: 48
          }
        }, {
          start: {
            line: 42,
            column: 51
          },
          end: {
            line: 42,
            column: 56
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 31
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 47,
            column: 31
          }
        }],
        line: 47
      },
      "2": {
        loc: {
          start: {
            line: 53,
            column: 12
          },
          end: {
            line: 53,
            column: 36
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 53,
            column: 19
          },
          end: {
            line: 53,
            column: 36
          }
        }],
        line: 53
      },
      "3": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 42
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 54,
            column: 42
          }
        }],
        line: 54
      },
      "4": {
        loc: {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        }, {
          start: {
            line: 66,
            column: 4
          },
          end: {
            line: 71,
            column: 5
          }
        }],
        line: 66
      },
      "5": {
        loc: {
          start: {
            line: 69,
            column: 19
          },
          end: {
            line: 69,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 28
          },
          end: {
            line: 69,
            column: 37
          }
        }, {
          start: {
            line: 69,
            column: 40
          },
          end: {
            line: 69,
            column: 41
          }
        }],
        line: 69
      },
      "6": {
        loc: {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 70,
            column: 47
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 70,
            column: 47
          }
        }, {
          start: {
            line: 70,
            column: 6
          },
          end: {
            line: 70,
            column: 47
          }
        }],
        line: 70
      },
      "7": {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 55
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 55
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 73,
            column: 55
          }
        }],
        line: 73
      },
      "8": {
        loc: {
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 42
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 73,
            column: 8
          },
          end: {
            line: 73,
            column: 19
          }
        }, {
          start: {
            line: 73,
            column: 23
          },
          end: {
            line: 73,
            column: 34
          }
        }, {
          start: {
            line: 73,
            column: 38
          },
          end: {
            line: 73,
            column: 42
          }
        }],
        line: 73
      },
      "9": {
        loc: {
          start: {
            line: 77,
            column: 37
          },
          end: {
            line: 77,
            column: 84
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 77,
            column: 49
          },
          end: {
            line: 77,
            column: 72
          }
        }, {
          start: {
            line: 77,
            column: 75
          },
          end: {
            line: 77,
            column: 84
          }
        }],
        line: 77
      },
      "10": {
        loc: {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }, {
          start: {
            line: 85,
            column: 4
          },
          end: {
            line: 87,
            column: 5
          }
        }],
        line: 85
      },
      "11": {
        loc: {
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 85,
            column: 110
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 85,
            column: 8
          },
          end: {
            line: 85,
            column: 17
          }
        }, {
          start: {
            line: 85,
            column: 21
          },
          end: {
            line: 85,
            column: 110
          }
        }],
        line: 85
      },
      "12": {
        loc: {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        }, {
          start: {
            line: 88,
            column: 4
          },
          end: {
            line: 91,
            column: 5
          }
        }],
        line: 88
      },
      "13": {
        loc: {
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 88,
            column: 47
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 88,
            column: 8
          },
          end: {
            line: 88,
            column: 17
          }
        }, {
          start: {
            line: 88,
            column: 21
          },
          end: {
            line: 88,
            column: 47
          }
        }],
        line: 88
      },
      "14": {
        loc: {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 62
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 62
          }
        }, {
          start: {
            line: 95,
            column: 4
          },
          end: {
            line: 95,
            column: 62
          }
        }],
        line: 95
      },
      "15": {
        loc: {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        }, {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 112,
            column: 5
          }
        }],
        line: 108
      },
      "16": {
        loc: {
          start: {
            line: 109,
            column: 15
          },
          end: {
            line: 109,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 109,
            column: 43
          },
          end: {
            line: 109,
            column: 46
          }
        }, {
          start: {
            line: 109,
            column: 49
          },
          end: {
            line: 109,
            column: 50
          }
        }],
        line: 109
      },
      "17": {
        loc: {
          start: {
            line: 111,
            column: 15
          },
          end: {
            line: 111,
            column: 50
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 111,
            column: 43
          },
          end: {
            line: 111,
            column: 46
          }
        }, {
          start: {
            line: 111,
            column: 49
          },
          end: {
            line: 111,
            column: 50
          }
        }],
        line: 111
      },
      "18": {
        loc: {
          start: {
            line: 117,
            column: 24
          },
          end: {
            line: 117,
            column: 46
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 117,
            column: 30
          },
          end: {
            line: 117,
            column: 46
          }
        }],
        line: 117
      },
      "19": {
        loc: {
          start: {
            line: 127,
            column: 47
          },
          end: {
            line: 127,
            column: 104
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 127,
            column: 84
          },
          end: {
            line: 127,
            column: 92
          }
        }, {
          start: {
            line: 127,
            column: 95
          },
          end: {
            line: 127,
            column: 104
          }
        }],
        line: 127
      },
      "20": {
        loc: {
          start: {
            line: 127,
            column: 47
          },
          end: {
            line: 127,
            column: 81
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 127,
            column: 47
          },
          end: {
            line: 127,
            column: 56
          }
        }, {
          start: {
            line: 127,
            column: 60
          },
          end: {
            line: 127,
            column: 81
          }
        }],
        line: 127
      },
      "21": {
        loc: {
          start: {
            line: 137,
            column: 19
          },
          end: {
            line: 137,
            column: 41
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 137,
            column: 25
          },
          end: {
            line: 137,
            column: 41
          }
        }],
        line: 137
      },
      "22": {
        loc: {
          start: {
            line: 137,
            column: 43
          },
          end: {
            line: 137,
            column: 67
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 137,
            column: 50
          },
          end: {
            line: 137,
            column: 67
          }
        }],
        line: 137
      },
      "23": {
        loc: {
          start: {
            line: 148,
            column: 25
          },
          end: {
            line: 148,
            column: 82
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 148,
            column: 37
          },
          end: {
            line: 148,
            column: 70
          }
        }, {
          start: {
            line: 148,
            column: 73
          },
          end: {
            line: 148,
            column: 82
          }
        }],
        line: 148
      },
      "24": {
        loc: {
          start: {
            line: 149,
            column: 26
          },
          end: {
            line: 149,
            column: 85
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 149,
            column: 39
          },
          end: {
            line: 149,
            column: 73
          }
        }, {
          start: {
            line: 149,
            column: 76
          },
          end: {
            line: 149,
            column: 85
          }
        }],
        line: 149
      },
      "25": {
        loc: {
          start: {
            line: 157,
            column: 13
          },
          end: {
            line: 157,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 157,
            column: 25
          },
          end: {
            line: 157,
            column: 47
          }
        }, {
          start: {
            line: 157,
            column: 50
          },
          end: {
            line: 157,
            column: 69
          }
        }],
        line: 157
      },
      "26": {
        loc: {
          start: {
            line: 158,
            column: 13
          },
          end: {
            line: 158,
            column: 102
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 158,
            column: 13
          },
          end: {
            line: 158,
            column: 32
          }
        }, {
          start: {
            line: 158,
            column: 36
          },
          end: {
            line: 158,
            column: 102
          }
        }],
        line: 158
      },
      "27": {
        loc: {
          start: {
            line: 167,
            column: 19
          },
          end: {
            line: 167,
            column: 45
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 167,
            column: 27
          },
          end: {
            line: 167,
            column: 45
          }
        }],
        line: 167
      },
      "28": {
        loc: {
          start: {
            line: 167,
            column: 47
          },
          end: {
            line: 167,
            column: 69
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 167,
            column: 53
          },
          end: {
            line: 167,
            column: 69
          }
        }],
        line: 167
      },
      "29": {
        loc: {
          start: {
            line: 167,
            column: 71
          },
          end: {
            line: 167,
            column: 95
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 167,
            column: 78
          },
          end: {
            line: 167,
            column: 95
          }
        }],
        line: 167
      },
      "30": {
        loc: {
          start: {
            line: 174,
            column: 13
          },
          end: {
            line: 174,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 174,
            column: 13
          },
          end: {
            line: 174,
            column: 22
          }
        }, {
          start: {
            line: 174,
            column: 26
          },
          end: {
            line: 174,
            column: 48
          }
        }],
        line: 174
      },
      "31": {
        loc: {
          start: {
            line: 183,
            column: 48
          },
          end: {
            line: 183,
            column: 64
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 183,
            column: 48
          },
          end: {
            line: 183,
            column: 55
          }
        }, {
          start: {
            line: 183,
            column: 59
          },
          end: {
            line: 183,
            column: 64
          }
        }],
        line: 183
      },
      "32": {
        loc: {
          start: {
            line: 188,
            column: 9
          },
          end: {
            line: 188,
            column: 70
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 188,
            column: 31
          },
          end: {
            line: 188,
            column: 50
          }
        }, {
          start: {
            line: 188,
            column: 53
          },
          end: {
            line: 188,
            column: 70
          }
        }],
        line: 188
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0],
      "22": [0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0],
      "28": [0],
      "29": [0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/10008649/Desktop/workspace/fe/shein/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
var _jsxFileName = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Rate/Rate.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { isRTL } from '../config';
import { PureComponent } from '../component';
import { range } from '../utils/numbers';
import { defaultProps } from '../utils/defaultProps';
import { rateClass } from './styles';
import getDataset from '../utils/dom/getDataset';
var MIN_SIZE = (cov_2mn452mohk.s[0]++, 12);
var DefaultProps = (cov_2mn452mohk.s[1]++, _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  repeat: true,
  max: 5,
  size: 20,
  text: [],
  value: 0
}));

var Rate =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Rate, _PureComponent);

  var _super = _createSuper2(Rate);

  function Rate(props) {
    var _this;

    _classCallCheck(this, Rate);

    cov_2mn452mohk.f[0]++;
    cov_2mn452mohk.s[2]++;
    _this = _super.call(this, props);
    _this.highlightTimer = void 0;
    cov_2mn452mohk.s[3]++;
    _this.state = {
      hover: 0,
      highlight: -1
    };
    return _this;
  }

  _createClass(Rate, [{
    key: "getValue",
    value: function getValue() {
      cov_2mn452mohk.f[1]++;

      var _ref = (cov_2mn452mohk.s[4]++, this.state),
          hover = _ref.hover;

      cov_2mn452mohk.s[5]++;
      return Number(hover === 0 ? (cov_2mn452mohk.b[0][0]++, this.props.value) : (cov_2mn452mohk.b[0][1]++, hover));
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      cov_2mn452mohk.f[2]++;

      var _ref2 = (cov_2mn452mohk.s[6]++, this.props),
          size = _ref2.size;

      cov_2mn452mohk.s[7]++;

      if (!size) {
        cov_2mn452mohk.b[1][0]++;
        cov_2mn452mohk.s[8]++;
        return undefined;
      } else {
        cov_2mn452mohk.b[1][1]++;
      }

      var parsed = (cov_2mn452mohk.s[9]++, Math.max(MIN_SIZE, parseFloat("".concat(size))));
      cov_2mn452mohk.s[10]++;
      return {
        width: parsed,
        fontSize: parsed,
        position: 'relative'
      };
    }
  }, {
    key: "getScale",
    value: function getScale() {
      cov_2mn452mohk.f[3]++;

      var _ref3 = (cov_2mn452mohk.s[11]++, this.props),
          _ref3$size = _ref3.size,
          size = _ref3$size === void 0 ? (cov_2mn452mohk.b[2][0]++, DefaultProps.size) : _ref3$size;

      cov_2mn452mohk.s[12]++;

      if (size >= MIN_SIZE) {
        cov_2mn452mohk.b[3][0]++;
        cov_2mn452mohk.s[13]++;
        return undefined;
      } else {
        cov_2mn452mohk.b[3][1]++;
      }

      cov_2mn452mohk.s[14]++;
      return {
        transform: "scale(".concat(Number(size) / MIN_SIZE, ")")
      };
    }
  }, {
    key: "getIcon",
    value: function getIcon(icons, i, isBg) {
      cov_2mn452mohk.f[4]++;

      var _ref4 = (cov_2mn452mohk.s[15]++, this.props),
          repeat = _ref4.repeat,
          allowHalf = _ref4.allowHalf;

      var value = (cov_2mn452mohk.s[16]++, this.getValue());
      var remain = (cov_2mn452mohk.s[17]++, value - i);
      var icon;
      cov_2mn452mohk.s[18]++;

      if (!Array.isArray(icons)) {
        cov_2mn452mohk.b[4][0]++;
        cov_2mn452mohk.s[19]++;
        icon = icons;
      } else {
        cov_2mn452mohk.b[4][1]++;
        cov_2mn452mohk.s[20]++;
        icon = icons[repeat ? (cov_2mn452mohk.b[5][0]++, value - 1) : (cov_2mn452mohk.b[5][1]++, i)];
        cov_2mn452mohk.s[21]++;

        if (!icon) {
          cov_2mn452mohk.b[6][0]++;
          cov_2mn452mohk.s[22]++;
          icon = icons[icons.length - 1];
        } else {
          cov_2mn452mohk.b[6][1]++;
        }
      }

      cov_2mn452mohk.s[23]++;

      if ((cov_2mn452mohk.b[8][0]++, remain <= 0) || (cov_2mn452mohk.b[8][1]++, remain >= 1) || (cov_2mn452mohk.b[8][2]++, isBg)) {
        cov_2mn452mohk.b[7][0]++;
        cov_2mn452mohk.s[24]++;
        return icon;
      } else {
        cov_2mn452mohk.b[7][1]++;
      }

      var style = (cov_2mn452mohk.s[25]++, {
        width: "".concat(remain * 100, "%"),
        display: 'block',
        overflow: 'hidden',
        fontSize: 'inherit'
      });
      cov_2mn452mohk.s[26]++;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          style: style,
          className: allowHalf ? (cov_2mn452mohk.b[9][0]++, rateClass('allow-half')) : (cov_2mn452mohk.b[9][1]++, undefined),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 77,
            columnNumber: 7
          }
        }, icon)
      );
    }
  }, {
    key: "handleClick",
    value: function handleClick(value, e) {
      var _this2 = this;

      cov_2mn452mohk.f[5]++;

      var _ref5 = (cov_2mn452mohk.s[27]++, this.props),
          clearable = _ref5.clearable,
          allowHalf = _ref5.allowHalf;

      cov_2mn452mohk.s[28]++;

      if ((cov_2mn452mohk.b[11][0]++, allowHalf) && (cov_2mn452mohk.b[11][1]++, e.target.parentElement.querySelector(".".concat(rateClass('allow-half'))))) {
        cov_2mn452mohk.b[10][0]++;
        cov_2mn452mohk.s[29]++;
        value -= 0.5;
      } else {
        cov_2mn452mohk.b[10][1]++;
      }

      cov_2mn452mohk.s[30]++;

      if ((cov_2mn452mohk.b[13][0]++, clearable) && (cov_2mn452mohk.b[13][1]++, this.props.value === value)) {
        cov_2mn452mohk.b[12][0]++;
        cov_2mn452mohk.s[31]++;
        value = 0;
        cov_2mn452mohk.s[32]++;
        this.setState({
          hover: 0
        });
      } else {
        cov_2mn452mohk.b[12][1]++;
      }

      cov_2mn452mohk.s[33]++;
      this.props.onChange(value);
      cov_2mn452mohk.s[34]++;
      this.setState({
        highlight: value
      });
      cov_2mn452mohk.s[35]++;

      if (this.highlightTimer) {
        cov_2mn452mohk.b[14][0]++;
        cov_2mn452mohk.s[36]++;
        clearTimeout(this.highlightTimer);
      } else {
        cov_2mn452mohk.b[14][1]++;
      }

      cov_2mn452mohk.s[37]++;
      this.highlightTimer = setTimeout(function () {
        cov_2mn452mohk.f[6]++;
        cov_2mn452mohk.s[38]++;

        _this2.setState({
          highlight: -1
        });
      }, 300);
    }
  }, {
    key: "handleHover",
    value: function handleHover(hover) {
      cov_2mn452mohk.f[7]++;
      cov_2mn452mohk.s[39]++;
      this.setState({
        hover: hover
      });
    }
  }, {
    key: "handleMove",
    value: function handleMove(hover, e) {
      cov_2mn452mohk.f[8]++;

      var _ref6 = (cov_2mn452mohk.s[40]++, e.target.getBoundingClientRect()),
          x = _ref6.x,
          width = _ref6.width;

      var offset;
      cov_2mn452mohk.s[41]++;

      if (isRTL()) {
        cov_2mn452mohk.b[15][0]++;
        cov_2mn452mohk.s[42]++;
        offset = x + width / 2 < e.clientX ? (cov_2mn452mohk.b[16][0]++, 0.5) : (cov_2mn452mohk.b[16][1]++, 0);
      } else {
        cov_2mn452mohk.b[15][1]++;
        cov_2mn452mohk.s[43]++;
        offset = x + width / 2 > e.clientX ? (cov_2mn452mohk.b[17][0]++, 0.5) : (cov_2mn452mohk.b[17][1]++, 0);
      }

      cov_2mn452mohk.s[44]++;
      this.setState({
        hover: hover - offset
      });
    }
  }, {
    key: "renderBackground",
    value: function renderBackground() {
      var _this3 = this;

      cov_2mn452mohk.f[9]++;

      var _ref7 = (cov_2mn452mohk.s[45]++, this.props),
          background = _ref7.background,
          _ref7$max = _ref7.max,
          max = _ref7$max === void 0 ? (cov_2mn452mohk.b[18][0]++, DefaultProps.max) : _ref7$max,
          disabled = _ref7.disabled;

      var style = (cov_2mn452mohk.s[46]++, this.getStyle());
      var value = (cov_2mn452mohk.s[47]++, this.getValue());
      cov_2mn452mohk.s[48]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: rateClass('background'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 122,
            columnNumber: 7
          }
        }, range(max).map(function (v) {
          cov_2mn452mohk.f[10]++;
          cov_2mn452mohk.s[49]++;
          return (
            /*#__PURE__*/
            React.createElement("span", {
              key: v // the allowHalf only for the front same as background
              ,
              style: Object.assign({
                visibility: (cov_2mn452mohk.b[20][0]++, !disabled) && (cov_2mn452mohk.b[20][1]++, Math.floor(value) > v) ? (cov_2mn452mohk.b[19][0]++, 'hidden') : (cov_2mn452mohk.b[19][1]++, 'visible')
              }, style),
              __self: _this3,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 124,
                columnNumber: 11
              }
            }, _this3.getIcon(background, v, true))
          );
        }))
      );
    }
  }, {
    key: "renderRate",
    value: function renderRate() {
      var _this4 = this;

      cov_2mn452mohk.f[11]++;

      var _ref8 = (cov_2mn452mohk.s[50]++, this.props),
          front = _ref8.front,
          _ref8$max = _ref8.max,
          max = _ref8$max === void 0 ? (cov_2mn452mohk.b[21][0]++, DefaultProps.max) : _ref8$max,
          _ref8$text = _ref8.text,
          text = _ref8$text === void 0 ? (cov_2mn452mohk.b[22][0]++, DefaultProps.text) : _ref8$text,
          allowHalf = _ref8.allowHalf;

      var _ref9 = (cov_2mn452mohk.s[51]++, this.state),
          highlight = _ref9.highlight;

      var value = (cov_2mn452mohk.s[52]++, this.getValue());
      var style = (cov_2mn452mohk.s[53]++, this.getStyle());
      cov_2mn452mohk.s[54]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: rateClass('front'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 143,
            columnNumber: 7
          }
        }, range(max).map(function (v) {
          cov_2mn452mohk.f[12]++;
          cov_2mn452mohk.s[55]++;
          return (
            /*#__PURE__*/
            React.createElement("span", {
              key: v,
              onClick: _this4.handleClick.bind(_this4, v + 1),
              onMouseMove: allowHalf ? (cov_2mn452mohk.b[23][0]++, _this4.handleMove.bind(_this4, v + 1)) : (cov_2mn452mohk.b[23][1]++, undefined),
              onMouseEnter: !allowHalf ? (cov_2mn452mohk.b[24][0]++, _this4.handleHover.bind(_this4, v + 1)) : (cov_2mn452mohk.b[24][1]++, undefined),
              style: style,
              __self: _this4,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 145,
                columnNumber: 11
              }
            },
            /*#__PURE__*/
            React.createElement("div", {
              style: {
                position: 'absolute',
                top: 0,
                right: 0,
                left: 0,
                bottom: 0
              },
              onMouseLeave: _this4.handleHover.bind(_this4, 0),
              __self: _this4,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 153,
                columnNumber: 13
              }
            }), value > v ? (cov_2mn452mohk.b[25][0]++, _this4.getIcon(front, v)) : (cov_2mn452mohk.b[25][1]++,
            /*#__PURE__*/
            React.createElement("span", {
              __self: _this4,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 157,
                columnNumber: 51
              }
            }, "\xA0")), (cov_2mn452mohk.b[26][0]++, highlight === v + 1) && (cov_2mn452mohk.b[26][1]++,
            /*#__PURE__*/
            React.createElement("i", {
              className: rateClass('highlight'),
              __self: _this4,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 158,
                columnNumber: 37
              }
            }, _this4.getIcon(front, v))))
          );
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: rateClass('text'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 161,
            columnNumber: 9
          }
        }, text[Math.ceil(value) - 1]))
      );
    }
  }, {
    key: "renderStatic",
    value: function renderStatic() {
      var _this5 = this;

      cov_2mn452mohk.f[13]++;

      var _ref10 = (cov_2mn452mohk.s[56]++, this.props),
          front = _ref10.front,
          _ref10$value = _ref10.value,
          value = _ref10$value === void 0 ? (cov_2mn452mohk.b[27][0]++, DefaultProps.value) : _ref10$value,
          _ref10$max = _ref10.max,
          max = _ref10$max === void 0 ? (cov_2mn452mohk.b[28][0]++, DefaultProps.max) : _ref10$max,
          _ref10$text = _ref10.text,
          text = _ref10$text === void 0 ? (cov_2mn452mohk.b[29][0]++, DefaultProps.text) : _ref10$text;

      var style = (cov_2mn452mohk.s[57]++, this.getStyle());
      cov_2mn452mohk.s[58]++;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: rateClass('static'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 171,
            columnNumber: 7
          }
        }, range(max).map(function (v) {
          cov_2mn452mohk.f[14]++;
          cov_2mn452mohk.s[59]++;
          return (
            /*#__PURE__*/
            React.createElement("span", {
              key: v,
              style: style,
              __self: _this5,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 173,
                columnNumber: 11
              }
            }, (cov_2mn452mohk.b[30][0]++, value > v) && (cov_2mn452mohk.b[30][1]++, _this5.getIcon(front, v)))
          );
        }),
        /*#__PURE__*/
        React.createElement("span", {
          className: rateClass('text'),
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 177,
            columnNumber: 9
          }
        }, text[Math.ceil(value) - 1]))
      );
    }
  }, {
    key: "render",
    value: function render() {
      cov_2mn452mohk.f[15]++;
      var className = (cov_2mn452mohk.s[60]++, classnames(rateClass('_', (cov_2mn452mohk.b[31][0]++, isRTL()) && (cov_2mn452mohk.b[31][1]++, 'rtl')), this.props.className));
      var ms = (cov_2mn452mohk.s[61]++, Object.assign({}, this.props.style, this.getScale()));
      cov_2mn452mohk.s[62]++;
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({
          className: className,
          style: ms
        }, getDataset(this.props), {
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 186,
            columnNumber: 7
          }
        }), this.renderBackground(), this.props.disabled ? (cov_2mn452mohk.b[32][0]++, this.renderStatic()) : (cov_2mn452mohk.b[32][1]++, this.renderRate()))
      );
    }
  }]);

  return Rate;
}(PureComponent);

Rate.defaultProps = DefaultProps;
export default Rate;